import { StoreData } from 'app/types-shared';
import * as resolvers from 'app/infrastructure/ui/renderer/resolvers';
import { getById } from 'app/infrastructure/store/query';
import { CaseState } from 'app/area/case/types-store';
import { contextToStorePath } from 'app/infrastructure/ui/renderer/resolvers';

export const primaryKeyFromEntity = (propName: string = 'primaryKey') => (
  state: CaseState,
  uiEngineProps: any
) => {
  const caseData: StoreData = resolvers.getCaseData(state, uiEngineProps);

  const entityContext = resolvers.getEntityContext(state, uiEngineProps);

  const entity = getById(
    caseData,
    contextToStorePath(uiEngineProps.componentDescriptor, entityContext)
  );

  return {
    [propName]: entity && entity.primaryKey
  };
};
